<!--
 * @Author: DY
 * @Date: 2024-11-21 14:41:15
 * @LastEditTime: 2025-04-09 18:41:50
 * @Description: 采购计划审批【采购管理】
 * @FilePath: \ShiMo_Mobile\src\views\purchase\planApproval\index.vue
-->
<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="planApproval commonListStyles">
            <van-nav-bar left-arrow :style="`height: ${ $getNavHeight() }px;`" @click-left="swiperright">
                <template #title>
                    <div :class="{'active': listType == 0}" @click="listSwitch(0)">
                        待审批
                    </div>
                    <div :class="{'active': listType == 1}" @click="listSwitch(1)">
                        已审批
                    </div>
                    <div :class="{'active': listType == 2}" @click="listSwitch(2)">
                        抄送
                    </div>
                </template>
            </van-nav-bar>
            <section>
                <van-search v-model="keyVal" placeholder="请输入搜索信息" @change="onRefresh"></van-search>
                <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                    <van-list
                        v-model="isUpLoading"
                        finished-text="没有更多了!"
                        :finished="finished"
                        @load="onLoad"
                    >
                        <ul class="list">
                            <li class="listItem" v-for="(item,index) in listData" :key="`item_${index}`">
                                <div class="engineeringInfo">
                                    <h4 class="itemTitle">
                                        <span class="iconfont iconhetong">审批编号：{{ item.collect_number }}</span>
                                    </h4>
                                    <p class="itemStatus" v-if="listType != 2">
                                        {{ listType == 0 ? '待审批' : '已审批' }}
                                    </p>
                                    <p class="itemStatus" v-else>
                                        {{ item.collect_status_str }}
                                    </p>
                                    <div class="itemContent">
                                        <p>
                                            <img src="@/assets/images/icons/icon_23@2x.png" alt="">
                                            <span>审批类型：{{ item.check_type }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_7@2x.png" alt="">
                                            <span>日期：{{ item.month }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_5@2x.png" alt="">
                                            <span>申请方式：{{ item.method_str }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_6@2x.png" alt="">
                                            <span>预算含税总价（元）：{{ item.budget_total }}</span>
                                        </p>
                                        <template v-if="listType != 2">
                                            <p>
                                                <img src="@/assets/images/icons/icon_8@2x.png" alt="">
                                                <span>提交人：{{ item.submitor }}</span>
                                            </p>
                                            <p>
                                                <img src="@/assets/images/icons/icon_7@2x.png" alt="">
                                                <span>提交时间：{{ item.submit_time }}</span>
                                            </p>
                                        </template>
                                        <template v-else>
                                            <p>
                                                <img src="@/assets/images/icons/icon_8@2x.png" alt="">
                                                <span>提交人：{{ item.user_name }}</span>
                                            </p>
                                            <p>
                                                <img src="@/assets/images/icons/icon_7@2x.png" alt="">
                                                <span>提交时间：{{ item.creation_time }}</span>
                                            </p>
                                        </template>
                                    </div>
                                    <div class="itemBtn itemBtns">
                                        <button v-if="listType == 0" @click="openApprovalProcess(item)">
                                            审批
                                        </button>
                                        <button v-if="listType == 1" @click="openApprovalProcess(item, 'see', 'view')">
                                            查看
                                        </button>
                                        <button v-if="listType == 2" @click="openApprovalProcess(item, '', item.isread == 0 ? 'read' : 'view')">
                                            查阅
                                        </button>
                                        <button v-if="item.apply_status == 2 && item.type == 2" @click="issued(item)">
                                            下发
                                        </button>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </van-list>
                </van-pull-refresh>
            </section>
        </div>
    </v-touch>
</template>

<script>
import { mixin_list } from '@/assets/mixin/mixin_list';
export default {
    name: 'plan-approval',
    mixins: [mixin_list],
    beforeRouteLeave(to, from, next) {
        if (to.path === '/home') {
            this.$store.commit('noKeepAlive', 'plan-approval');
        }
        next();
    },
    data() {
        return {
            listType: 0,
            requestUrl: '/basicplatform/tabledata?checked=0',
            tableCode: 'plan_collect_huge_list_app_pending_approve',
        };
    },
    filters: {},
    computed: {},
    watch: {},
    activated() {
        if (this.$route.params.isRefresh) {
            this.finished = false;
            this.listData = [];
            this.pageIndex = 0;
            this.onRefresh();
        }
    },
    created() {
        this.cacheKey = Math.floor(Math.random() * 1000000000000 + 1);
    },
    mounted() {},
    methods: {
        loadRequestData() {
            return {
                code: this.tableCode,
                cacheKey: this.cacheKey,
                checked: this.listType,
                [this.indexKey]: this.pageIndex,
                [this.sizeKey]: this.pageSize,
                [this.searchKey]: this.keyVal,
            };
        },
        // 待办已办切换
        listSwitch(type) {
            this.listType = type;
            this.cacheKey = Math.floor(Math.random() * 1000000000000 + 1);
            this.requestUrl = `/basicplatform/tabledata?checked=${type}`;
            if (type === 0) {
                this.tableCode = 'plan_collect_huge_list_app_pending_approve';
            } else if (type === 1) {
                this.tableCode = 'plan_collect_huge_list_app';
            } else if (type === 2) {
                this.tableCode = 'plan_all_check_read';
            }
            this.onRefresh();
        },

        // 打开合同审批页
        openApprovalProcess(data, type, view) {
            data.BusinessInstanceId = data.business_instance_id;
            this.$router.isBack = 2;
            this.$router.push({
                name: 'approvalProcess',
                params: {
                    data: data,
                    platformEnterprises: data.tenant_id,
                    isReadOnly: type === 'see' ? true : false,
                    view,
                },
            });
        },
        issued(item) {
            this.$dialog.confirm({
                message: '确认下发？',
            }).then(async () => {
                try {
                    await this.issuedRequrst(item.id);
                    this.$toast.success('下发成功。');
                    this.onRefresh();
                } catch (error) {
                    this.$toast(error.ErrorCode.Message);
                }
            });
        },
        issuedRequrst(id) {
            return this.$axios.$post(`interfaceApi/procurement/plan_collect_huge/distribute/${id}`, {});
        },
    },
};
</script>
<style lang="stylus">
.planApproval
    .van-nav-bar
        .van-nav-bar__title
            div
                display inline-block
                padding 0 15rpx
                font-size 14rpx
                color rgba(240,240,240,0.7)
                transition 0.2s
                &.active
                    font-size 18rpx
                    color #fff
    section
        .van-pull-refresh
            height: calc(100% - 42rpx) !important
</style>
